



























































import { ExceptionReportClient } from '@/shared/exception-reports/exception-report.client';
import { NoLongerProceedingClients } from '@/shared/exception-reports/no-longer-proceeding-clients';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class NoLongerProceedingClientsTable extends Vue {
    @Prop({ required: true }) private appointments!: Array<NoLongerProceedingClients & { showProducts: boolean }>;
    @Prop({ required: true }) private emptyText!: string;

    private currentPage: number = 1;
    private pageSize: number = 50;

    private get fields(): Array<{}> {
        return [
            { key: 'appointmentDate', label: 'Appointment Date' },
            { key: 'appointmentTime', label: 'Appointment Time' },
            { key: 'partnerPractice', label: 'Assigned To' },
            { key: 'legalAdvisor', label: 'Legal Advisor' },
            { key: 'accountNo', label: 'Account No' },
            { key: 'clientName', label: 'Client Name' },
            { key: 'products', label: 'Product/Payment Status/Amount' },
            { key: 'date', label: 'Date' },
            { key: 'appointmentNotes', label: 'Appointment Notes' },
        ];
    }

    private get totalRows(): number {
        return this.appointments.length;
    }

    private get paginationDescription(): string {
        const start: number = (this.appointments.length < 1) ? 0 : ((this.currentPage - 1) * this.pageSize) + 1;
        const end: number = start + this.pageSize > this.totalRows ? this.totalRows : start + this.pageSize - 1;

        return `Showing ${start.toLocaleString()} - ${end.toLocaleString()} of ${this.totalRows.toLocaleString()}`;
    }

    private get startDate(): string | Date | null {
        const dates = this.appointments.map((a) => a.appointmentDate)
            .sort((d1, d2) => {
                if (d1! > d2!) { return 1; }
                if (d1! < d2!) { return -1; }
                return 0;
            });

        return dates[0];
    }

    private get endDate(): string | Date | null {
        const dates = this.appointments.map((a) => a.appointmentDate)
            .sort((d1, d2) => {
                if (d1! < d2!) { return 1; }
                if (d1! > d2!) { return -1; }
                return 0;
            });

        return dates[0];
    }

    @Watch('appointments')
    private onAppointmentsChanged(): void {
        this.currentPage = 1;
    }

    private sortClients(clients: Array<ExceptionReportClient>): Array<ExceptionReportClient> {
        if (!clients.length) {
            return [];
        }

        if (clients.length < 2) {
            return [clients[0]];
        }

        const firstClient = clients[0].accountNo < clients[1].accountNo ? clients[0] : clients[1];
        const secondClient = clients[0].accountNo > clients[1].accountNo ? clients[0] : clients[1];

        return [
            firstClient,
            secondClient,
        ];
    }

    private clientName(clients: Array<ExceptionReportClient>): string {
        if (clients == null || clients.length < 1) {
            return '';
        }

        if (clients.length < 2) {
            return `${clients[0].firstName.trim()} ${clients[0].lastName.trim()}`;
        }

        const sortedClients = this.sortClients(clients);

        return sortedClients[0].lastName.trim().toLowerCase() === sortedClients[1].lastName.trim().toLowerCase()
            ? `${sortedClients[0].firstName.trim()} & ${sortedClients[1].firstName.trim()} ${sortedClients[0].lastName.trim()}`
            : `${sortedClients[0].firstName.trim()} ${sortedClients[0].lastName.trim()} & ${sortedClients[1].firstName.trim()} ${sortedClients[1].lastName.trim()}`;
    }

    private goToClient(clientId: string): void {
        window.open('../../clients/' + clientId, '_blank');
    }
}
